import { Route, useLocation, Redirect } from 'react-router-dom';
import {
  IonApp
} from '@ionic/react';
import { IonReactHashRouter, IonReactRouter } from '@ionic/react-router';
import { Browser } from 'detect-browser';

/* Theme Import css */
import './assets/css/bootstrap-datetimepicker.min.css';
import './assets/css/bootstrap.css';
import './assets/css/bootstrap.min.css';
import './assets/css/dataTables.bootstrap4.min.css';
import './assets/css/font-awesome.min.css';
import './assets/css/fullcalendar.min.css';
import './assets/css/line-awesome.min.css';
import './assets/css/select2.min.css';
import './assets/css/style.css';
import './assets/css/antdstyle.css';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css'
/* Theme variables */
import './theme/variables.css';
import Login from './pages/Login';
import SSOLogin from './pages/SSOLogin';
import HRHomePage from './pages/Homepage';
import Account from './pages/Account';
import HRDashboard from './pages/HR/Dashboard/HRDashboard';
// import HRLeave from './pages/HR/Leave/HRLeave';
import HRApproval from './pages/HR/Leave/HRApproval';
import AllApproval from './pages/HR/Leave/AllApproval';
import HRClient from './pages/HR/Client/HRClient';
import HRProject from './pages/HR/Project/HRProject';
import HRDesignation from './pages/HR/Designation/HRDesignation';
import HREmployementtype from './pages/HR/Employement Type/HREmployementtype';
import HRBusinessunit from './pages/HR/Bussiness Unit/HRBussinessunit';
import HRDepartmentunit from './pages/HR/Department Unit/HRDepartmentunit';
import HREmployeees from './pages/HR/Employees/HREmployees';
import HRViewEmployeee from './pages/HR/Employees/HRViewEmployee';
import HRCreateEmployeee from './pages/HR/Employees/HRCreateEmployee';
import HRUpdateEmployee from './pages/HR/Employees/HRUpdateEmployee';
import LeaveApply from './pages/MyLeave';
import MemberTimeLog from './pages/Team Member/MyTimelog';
import MemberTimeSheet from './pages/Team Member/MyTImesheet';
import ManagerTeams from './pages/Manager/MyTeams';
import ManagerLeaveApproval from './pages/Manager/LeaveApproval';
import ManagerTimeSheetApproval from './pages/Manager/TimeSheetApproval';
import ChangePassword from './pages/ChangePassword';
import HomePage from './pages/Homepage';
//import LandingSelector from './pages/LandingSelector';
import { useEffect, useState } from 'react';
import ActivityMeta from './pages/HR/ActivityMeta';
import TimeSheetReport from './pages/HR/TimesheetReport';
import LeaveHistory from './pages/LeaveHistory';
import LeaveBatchUpdate from './pages/LeaveBatchUpdate';
import ParentActivityMeta from './pages/HR/Parent Activity';
import { createBrowserHistory } from 'history';
import MetaActivityList from './pages/HR/MetaActivityList';
import HRDepartment from './pages/HR/Department/HRDepartment';
import MemberTimesheetHistory from './pages/Team Member/MemberTimesheetHistory';
import HRViewTimesheetHistory from './pages/HR/Employees/HRViewTimesheetHistory';
import TimesheetPending from './pages/Team Member/TimesheetPending';
import MissingTimesheetReport from './pages/Team Member/MissingTimesheetReport';
import ProjectReport from './pages/HR/ProjectReport';
import ProjectReportView from './pages/HR/ProjectReportView';
import ClientReport from './pages/HR/ClientReport';
import ActivityCreateProject from './pages/Team Member/ActivityCreateProject';
// import ActivityCreateProjectView from './pages/Team Member/ActivityCreateProjectView';
import ActivityReportingRelation from './pages/HR/ActivityReportingRelation';
import EmployeeExit from './pages/HR/EmployeeExit';
import LeaveReport from './pages/LeaveReport';
// import MyTestCalender from './pages/Team Member/MyTestCalender';
import GendralActivityAssign from './pages/HR/Project/GendralActivityAssign';
import Birthday from './pages/HR/Dashboard/EmployeesBirthday';
import PendingConfirmation from './pages/HR/Dashboard/PendingConfirm';
import HRProjectDashboard from './pages/HR/Dashboard/HRProjectDashboard';
import MissingTimesheet from './pages/MissingTimesheet';
import EmpBirthday from './pages/HR/Dashboard/EmployeesBirthday';
import TodayLeave from './pages/HR/Dashboard/Todaysleave';
import EmployeeDashboard from './pages/HR/Employee Dashboard/EmployeeDashboard';
import TPDashboard from './pages/HR/Dashboard/TPDashboard';
import MissingTsDashboard from './pages/HR/Dashboard/MissingTsDashboard';
import LeaveApproval from './pages/HR/Dashboard/Leaveapprovalpending';
import EmpProjectdash from './pages/HR/Employee Dashboard/EmployeeProjectdash';
import EmpEffortdash from './pages/HR/Employee Dashboard/EmployeeEffortdash';
import EmployeeTimeLog from './pages/HR/Employee Dashboard/EmployeeTimelogdash';
import EmpTimeLogdash from './pages/HR/Employee Dashboard/EmployeeTimelogdash';
import EmpLeavedash from './pages/HR/Employee Dashboard/EmployeeLeavedash';
import EmpTimesheetdash from './pages/HR/Employee Dashboard/EmployeeTimesheetdash';
import EmpMissingTimesheetdash from './pages/HR/Employee Dashboard/EmployeeMissingTimesheetdash';
import EmpTimesheethistorydash from './pages/HR/Employee Dashboard/EmployeeTimesheethistorydash';
import MyEmployeeDashboard from './pages/HR/Dashboard/MyEmployeeDashboard';
import ManagerEmployeDashboard from './pages/HR/Dashboard/ManagerEmployeDashboard';
import ProjectClosure from './pages/HR/ProjectClosure';
import ProjectClosureView from './pages/HR/ProjectClosureView';
import ResourceReport from './pages/HR/ResourceReport';
import Holiday from './pages/HR/Holiday';
import EmpHoliday from './pages/HR/EmpHoliday';
import Compoff from './pages/HR/Compoff';
import Employeeconfirm from './pages/HR/Employeeconfirmation';
import ManagerCompoff from './pages/HR/Managerregcompoff';
import CompoffReport from './pages/Compoffreport';
import Compoffhistory from './pages/HR/Compoffhistory';
import ViewCompoff from './pages/HR/Dashboard/PendingCompoff';
import PendingCompoff from './pages/HR/Dashboard/PendingCompoff';
import ManagerApplycompoff from './pages/HR/Managerleavecompoff';
import EmployeeLeaveupdate from './pages/Team Member/Empleaveupdate';
import EmpLeaveUpdateView from './pages/Team Member/Empleaveupdateview';
import TimelogDetailReport from './pages/Team Member/TimelogDetailReport';
import LeaveBalanceReport from './pages/HR/Leave/LeaveBalanceReport';
import EffortUtilize from './pages/Team Member/EffortUtilize';
// import BuReport from './pages/BuReport';
import keycloak from './lib/keycloak';
import process from 'process';
import SSOCallback from './pages/SSOCallback';



const App: React.FC = () => {
  const [token] = useState(localStorage.getItem("SignupEmpId"));

 
  const logout = () => {
  const loginType = localStorage.getItem("loginType");

  if (loginType === "keycloak") {
    localStorage.clear();
     // window.location.href = process.env.REACT_APP_KEYCLOAK_LOGIN_URL;
    keycloak.logout({
      redirectUri:  process.env.REACT_APP_KEYCLOAK_LOGIN_URL
    });
  } else {
    localStorage.clear();

    window.location.href = "/login";
  }
};
   
  var browser;

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    if (userAgent.includes('Chrome')) {
      browser = "Chorme"
    } else if (userAgent.includes('Safari')) {
      browser = "Safari"
    } else {
      browser = ""
    }

    if (browser) {
      document.body.classList.add(browser); // Add a CSS class based on the browser name
    }
  }, [browser]);


   const isSSOCallback =
        window.location.pathname.includes("/sso-callback");

    if (isSSOCallback) {
        return <SSOCallback />;
    }

  return (
    <IonApp>
      <IonReactHashRouter>
 
 <Route path="/" exact>
 <Login />
      {/* {localStorage.getItem("token") ? <Redirect to="/HRDashboard" /> : <Login />} */}
    </Route>
   {/* <Route path="/" exact>
      <HomePage />
    </Route> */}

    
    
 {/* <Route path="/" exact={true}>
           <HomePage />
</Route>   */}
 <Route path="/sso-login" exact={true}>
                  <SSOLogin />
                </Route>
                <Route path="/HomePage" exact={true}>
          <HomePage />
        </Route> 





        <Route path="/Account" exact={true}>
          <Account />
        </Route>
        <Route path="/HRDashboard">
          <HRDashboard />
        </Route>
        {/* <Route path="/HRLeave">
        <HRLeave />
      </Route> */}
        <Route path="/HRApproval">
          <HRApproval />
        </Route>
        <Route path="/AllApproval">
          <AllApproval />
        </Route>
        <Route path="/HRClient">
          <HRClient />
        </Route>
        <Route path="/HRProject">
          <HRProject />
        </Route>
        <Route path="/ActivityCreateProject">
          <ActivityCreateProject />
        </Route>
        <Route path="/GendralActivityAssign">
          <GendralActivityAssign />
        </Route>
        {/* <Route path="/ActivityCreateProjectView">
          <ActivityCreateProjectView/>
        </Route> */}
        <Route path="/HRDesignation">
          <HRDesignation />
        </Route>
        <Route path="/HREmployementtype">
          <HREmployementtype />
        </Route>
        <Route path="/HRBussinessunit">
          <HRBusinessunit />
        </Route>
        <Route path="/HRDepartmentunit">
          <HRDepartmentunit />
        </Route>
        <Route path="/ProjectClosure">
          <ProjectClosure></ProjectClosure>
        </Route>
        <Route path="/ProjectClosureView">
          <ProjectClosureView></ProjectClosureView>
        </Route>
        {/* ProjectClosureView */}
        {/* <Route path="/HRDepartmentunit">
          <HRDepartment></HRDepartment>
        </Route> */}
        <Route path="/HRProjectDashboard">
          <HRProjectDashboard />
        </Route>
        <Route path="/HRDepartment">
          <HRDepartment />
        </Route>
        <Route path="/HREmployees">
          <HREmployeees />
        </Route>
        <Route path="/HRViewEmployee">
          <HRViewEmployeee />
        </Route>
        <Route path="/HRViewTimesheetHistory">
          <HRViewTimesheetHistory />
        </Route>
        <Route path="/EmployeeExit">
          <EmployeeExit></EmployeeExit>
        </Route>
        {/* <Route path="/MyTestCalender">
          <MyTestCalender></MyTestCalender> */}
        {/* <EmployeeExit></EmployeeExit> */}
        {/* </Route> */}
        <Route path="/TimesheetPending">
          <TimesheetPending />
        </Route>
        <Route path="/MissingTimesheetReport">
          <MissingTimesheetReport />
        </Route>

        <Route path="/HRCreateEmployee">
          <HRCreateEmployeee />
        </Route>
        <Route path="/HRUpdateEmployee">
          <HRUpdateEmployee />
        </Route>
        <Route path="/LeaveApply">
          <LeaveApply />
        </Route>
        <Route path="/MemberTimeLog">
          <MemberTimeLog />
        </Route>
        <Route path="/MemberTimeSheet">
          <MemberTimeSheet />
        </Route>
        <Route path="/ManagerTeams">
          <ManagerTeams />
        </Route>
        <Route path="/ManagerLeaveApproval">
          <ManagerLeaveApproval />
        </Route>
        <Route path="/ManagerTimeSheetApproval">
          <ManagerTimeSheetApproval />
        </Route>
        <Route path="/MemberTimesheetHistory">
          <MemberTimesheetHistory />
        </Route>
        <Route path="/ChangePassword">
          <ChangePassword />
        </Route>
        <Route path="/HRActivityMeta">
          <ActivityMeta />
        </Route>
        <Route path="/HRMetaActivityList">
          <MetaActivityList />
        </Route>
        <Route path="/ProjectReport">
          <ProjectReport />
        </Route>'
        <Route path="/ClientReport">
          <ClientReport></ClientReport>
        </Route>
        <Route path="/ProjectReportView">
          <ProjectReportView />
        </Route>
        <Route path="/ActivityReportingRelation">
          <ActivityReportingRelation />
        </Route>
        <Route path="/TimeSheetReport">
          <TimeSheetReport />
        </Route>
        <Route path="/LeaveHistory">
          <LeaveHistory />
        </Route>
        <Route path="/LeaveBalanceReport">
          <LeaveBalanceReport />
        </Route>
        <Route path="/LeaveBatchUpdate">
          <LeaveBatchUpdate />
        </Route>
        <Route path="/ParentActivityMeta">
          <ParentActivityMeta />
        </Route>
        <Route path="/EmployeeDashboard">
          <EmployeeDashboard></EmployeeDashboard>
        </Route>
        <Route path="/HREmployeeDashboard">
          <MyEmployeeDashboard></MyEmployeeDashboard>
        </Route>
        <Route path="/MissingTsDashboard">
          <MissingTsDashboard></MissingTsDashboard>
        </Route>
        <Route path="/TPDashboard">
          <TPDashboard></TPDashboard>
        </Route>
        {/* ManagerEmployeDashboard */}
        <Route path="/ManagerEmployeDashboard">
          <ManagerEmployeDashboard></ManagerEmployeDashboard>
        </Route>
        <Route path="/LeaveReport">
          <LeaveReport></LeaveReport>
        </Route>
        {/* <Route path="/BuReport">
        <BuReport></BuReport>
        </Route> */}
        <Route path="/EmployeesBirthday">
          <EmpBirthday></EmpBirthday>
        </Route>
        <Route path="/Todaysleave">
          <TodayLeave></TodayLeave>
        </Route>
        <Route path="/PendingConfirm">
          <PendingConfirmation></PendingConfirmation>
        </Route>
        <Route path="/MissingTimesheet">
          <MissingTimesheet></MissingTimesheet>
        </Route>
        <Route path="/Leaveapprovalpending">
          <LeaveApproval></LeaveApproval>
        </Route>
        <Route path="/EmployeeProjectdash">
          <EmpProjectdash></EmpProjectdash>
        </Route>
        <Route path="/EmployeeEffortdash">
          <EmpEffortdash></EmpEffortdash>
        </Route>
        <Route path="/EmployeeTimelogdash">
          <EmpTimeLogdash></EmpTimeLogdash>
        </Route>
        <Route path="/EmployeeLeavedash">
          <EmpLeavedash></EmpLeavedash>
        </Route>
        <Route path="/EmployeeTimesheetdash">
          <EmpTimesheetdash></EmpTimesheetdash>
        </Route>
        <Route path="/EmployeeMissingTimesheetdash">
          <EmpMissingTimesheetdash></EmpMissingTimesheetdash>
        </Route>
        <Route path="/EmployeeTimesheethistorydash">
          <EmpTimesheethistorydash></EmpTimesheethistorydash>
        </Route>
        <Route path="/ResourceReport">
          <ResourceReport></ResourceReport>
        </Route>
        <Route path="/Holiday">
          <Holiday></Holiday>
        </Route>
        <Route path="/EmpHoliday">
          <EmpHoliday></EmpHoliday>
        </Route>
        <Route path="/Compoff">
          <Compoff></Compoff>
        </Route>
        <Route path="/Employeeconfirmation">
          <Employeeconfirm></Employeeconfirm>
        </Route>
        <Route path="/Managerregcompoff">
          <ManagerCompoff></ManagerCompoff>
        </Route>
        <Route path="/Compoffreport">
          <CompoffReport></CompoffReport>
        </Route>
        <Route path="/Compoffhistory">
          <Compoffhistory></Compoffhistory>
        </Route>
        <Route path="/PendingCompoff">
          <PendingCompoff></PendingCompoff>
        </Route>
        <Route path="/Managerleavecompoff">
          <ManagerApplycompoff></ManagerApplycompoff>
        </Route>
        <Route path="/Empleaveupdate">
          <EmployeeLeaveupdate></EmployeeLeaveupdate>
        </Route>
        <Route path="/EmpLeaveUpdateView">
          <EmpLeaveUpdateView></EmpLeaveUpdateView>
        </Route>
        <Route path="/TimelogDetailReport">
          <TimelogDetailReport></TimelogDetailReport>
        </Route>
        <Route path="/EffortUtilize">
       <EffortUtilize></EffortUtilize>
        </Route>
      </IonReactHashRouter >

    </IonApp>
  )
}

export default App;